<div class="p-d-flex p-dir-col p-jc-between" [ngStyle]="{'min-height': height }">
  <div>
    <dum-header *ngIf="!isAuth"></dum-header>
    <dum-header-private *ngIf="isAuth " [user]="userLogged"></dum-header-private>
    <div class="p-col-12 header-title" style="text-align: right;">
      <h2 style="margin-top: 0; margin-bottom: 0;">DUMinVAL</h2>
    </div>
    <dum-menu ></dum-menu>
  </div>
  <div class="p-d-flex">
    <div class="p-col-10 m-auto">
      <dum-content >
        <ng-content></ng-content>
      </dum-content>
    </div>
  </div>

  <dum-footer></dum-footer>
</div>
